import styled from 'styled-components'
import { mediaQueries } from 'theme'

const FooterContainer = styled.footer`
  bottom: 0px;
  position: fixed;
  width: 100%;
  display: flex;
  flex: 1 0 auto;
  flex-grow: unset;
  justify-content: center;
  background: black;
  border-top: 1px solid black;
  > * {
    color: white;
  }

  @media ${mediaQueries.greaterThanMedium} {
    height: auto;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 0;
  }
  @media ${mediaQueries.lessThanMedium} {
    align-items: center;
  }
`
const Footer = (): JSX.Element => {
  return (
    <FooterContainer>
      <a href="https://www.synchrony.com">
        &copy; {new Date().getFullYear()} Synchrony Bank
      </a>
    </FooterContainer>
  )
}

export default Footer
